import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { assetApi, type Asset, type AssetVersion, type QualityReport } from '../../api/media';

export function AssetDetailPage() {
  const { id = '' } = useParams();
  const [asset, setAsset] = useState<Asset | null>(null);
  const [versions, setVersions] = useState<AssetVersion[]>([]);
  const [quality, setQuality] = useState<QualityReport | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    Promise.all([assetApi.get(id), assetApi.versions(id), assetApi.quality(id)])
      .then(([a, v, q]) => { setAsset(a); setVersions(v); setQuality(q); })
      .catch((e) => setError(String(e)));
  }, [id]);

  if (error) return <p className="p-6 text-red-600">{error}</p>;
  if (!asset) return <p className="p-6">Loading…</p>;

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/media" className="text-sm text-slate-600 hover:underline">← Library</Link>
      <h1 className="mt-4 text-2xl font-semibold">{asset.name}</h1>
      <p className="text-sm capitalize text-slate-500">{asset.status.replace(/_/g, ' ')} · v{asset.version}</p>
      {asset.file_url && <img src={asset.file_url} alt={asset.name} className="mt-4 max-h-96 rounded-xl border object-contain" />}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 text-sm">
        <div className="rounded-xl border p-4">
          <p className="text-slate-500">Quality score</p>
          <p className="text-2xl font-semibold">{quality?.score ?? '—'}</p>
          <p className="capitalize text-slate-600">{quality?.status}</p>
        </div>
        <div className="rounded-xl border p-4">
          <p className="text-slate-500">Checksum</p>
          <p className="break-all font-mono text-xs">{asset.checksum || '—'}</p>
        </div>
      </div>
      <section className="mt-8">
        <h2 className="font-medium">Version history</h2>
        <ul className="mt-3 space-y-2 text-sm">
          {versions.map((v) => (
            <li key={v.id} className="rounded border px-3 py-2">v{v.version}{v.transform ? ` · ${v.transform}` : ''}</li>
          ))}
          {versions.length === 0 && <p className="text-slate-500">No versions recorded.</p>}
        </ul>
      </section>
      <div className="mt-4 flex gap-3 text-sm">
        <Link to={`/media/quality/${id}`} className="text-slate-700 hover:underline">Quality dashboard</Link>
      </div>
    </div>
  );
}
